export default "__VITE_ASSET__wAnvH_mb__"